import { Button, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import './EditModal.css';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';
import axiosApiInstance from '../axios';
import Avatar from '@mui/material/Avatar';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CAlertBox from '../CAlertBox/CAlertBox';

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: 55,
      height: 55,
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

const EditModal = ({ onProfileEdit, user, userProfile }) => {


  const [loading, setLoading] = useState(false)
  const [fileName, setFileName] = useState([]);
  const [imgFiles, setImgFiles] = useState([]);
  const [preview, setPreview] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');


  const onFileChange = (e) => {
    // const allAttach = Array.from(e.target.files).map((file)=>file)
    setImgFiles(e.target.files[0]);

    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader()

      reader.onload = function (e) {
        setFileName(e.target.result)
        setPreview(true)
      }
      reader.readAsDataURL(e.target.files[0])
    }
  }

  const remImg = () => {
    setFileName('')
    setPreview(false)
  }


  const fetchedToken = localStorage.getItem('token');

  const EditedForm = (e) => {
    setLoading(true)
    e.preventDefault();
    let bodyFormData = new FormData();

    bodyFormData.append('formFile', imgFiles);
    for (var pair of bodyFormData.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }
    axiosApiInstance.post('/user/UploadProfilePicture', bodyFormData).then(res => {
        if (res.data.succeeded === true) {
          onProfileEdit();
          setLoading(false)
        } if (res.data.succeeded === false) {
          setLoading(false);
          // alert("There was an error.Pls Try Again")
          setAlertMessage('Please Refresh and Try Again');
        }
      }).catch(err => {
        // alert(err);
        setAlertMessage(err);
      });
  }


  return (
    <>
      {!preview ? <>
        {/* <img src={user.profilePath ? user.profilePath : <AccountCircleIcon />} placeholder="Sample Image" /> */}
        <Avatar {...stringAvatar(user.fullName)}
        src={userProfile}
        />
        <label className="mdl-label">
         <ModeEditIcon className='add-icon'/>
          <input type="file" multiple onChange={onFileChange} className="mdl-input" />
        </label>
        </>

        :

        <>
          <img src={fileName ? fileName : <AccountCircleIcon />} alt="uploaded-img" />
          <button onClick={remImg} className="img-del" >
            <CloseIcon className="img-close" />
          </button>
        </>
      }


      <div className='button-class'>
        <Button className="save-btn" style={{
          backgroundColor: "#0A387D"
        }}
          variant="contained" onClick={EditedForm}>{loading ? <CircularProgress className='loader-class' /> : "Save"}</Button>
        <Button className="cancel-btn" onClick={onProfileEdit} style={{
          backgroundColor: "#707070"
        }}
          variant="contained">Cancel</Button>
      </div>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />
    </>
  );

};

export default EditModal;